(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homewoods-care"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hw-category-carousel'))customElements.define('hw-category-carousel',class extends HTMLElement{
 connectedCallback(){
  this.track=this.querySelector('.hw-care__grid');this.controls=this.querySelector('.hw-care__controls');
  if(!this.track||this.track.children.length<2)return;
  this.controls.hidden=false;this.prev=this.querySelector('[data-hw-prev]');this.next=this.querySelector('[data-hw-next]');
  this.abort=new AbortController();const options={signal:this.abort.signal};
  this.prev.addEventListener('click',()=>this.move(-1),options);this.next.addEventListener('click',()=>this.move(1),options);
  this.track.addEventListener('keydown',e=>{if(e.target===this.track&&['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();this.move(e.key==='ArrowRight'?1:-1);}},options);
  this.track.addEventListener('scroll',()=>this.update(),{...options,passive:true});
  this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);this.update();
 }
 move(direction){const cards=this.track.children;const index=Math.max(0,Math.min(cards.length-1,this.index+direction));const left=cards[index].offsetLeft-cards[0].offsetLeft;this.track.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
 update(){const cards=Array.from(this.track.children);const left=this.track.scrollLeft;this.index=cards.reduce((best,card,i)=>Math.abs(card.offsetLeft-cards[0].offsetLeft-left)<Math.abs(cards[best].offsetLeft-cards[0].offsetLeft-left)?i:best,0);this.prev.disabled=left<3;this.next.disabled=left>=this.track.scrollWidth-this.track.clientWidth-3;this.querySelector('[data-hw-position]').textContent=(this.index+1)+' / '+cards.length;}
 disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();}
});

  } catch(e) { console.error(e); }
})();
})();
